import { styled } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';

export const FormContainer = styled(Paper)(({ theme }) => ({
  padding: 0,
  backgroundColor: '#1e1e1e',
  color: '#ffffff',
  borderRadius: theme.spacing(1),
  marginBottom: theme.spacing(2),
  border: '1px solid #333'
}));

export const FormRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2)
}));

export const FormField = styled(Box)(({ theme }) => ({
  flex: '1 1 calc(50% - 16px)',
  minWidth: '240px'
}));

export const HeaderBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#1976d2',
  color: 'white',
  padding: theme.spacing(1.5),
  borderRadius: '4px 4px 0 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#1e1e1e',
  border: '1px solid #333',
  borderTop: 'none',
  padding: theme.spacing(3)
}));

export const DestinationChipsContainer = {
  display: 'flex',
  flexWrap: 'wrap' as const,
  gap: '8px',
  marginTop: '8px',
  width: '100%'
};

export const ChipNumberCircle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '16px',
  height: '16px',
  borderRadius: '50%',
  backgroundColor: 'rgba(255, 255, 255, 0.2)',
  marginRight: '8px',
  fontSize: '0.7rem'
};

export const DestinationChipStyles = {
  '& .MuiChip-root': {
    backgroundColor: 'rgba(33, 150, 243, 0.1)',
    border: '1px solid rgba(33, 150, 243, 0.3)',
    color: '#fff',
    '&:hover': {
      backgroundColor: 'rgba(33, 150, 243, 0.2)'
    }
  },
  '& .MuiChip-deleteIcon': {
    color: 'rgba(255, 255, 255, 0.7)',
    '&:hover': {
      color: '#fff'
    }
  },
  '& .MuiChip-label': {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 8px',
    color: '#fff'
  }
};

export const DestinationAutocomplete = {
  backgroundColor: 'rgba(25, 118, 210, 0.04)',
  borderRadius: 1,
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'rgba(25, 118, 210, 0.25)'
    },
    '&:hover fieldset': {
      borderColor: 'rgba(25, 118, 210, 0.4)'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#2196f3'
    }
  },
  '& .MuiInputBase-input': {
    color: '#fff'
  },
  '& .MuiInputLabel-root': {
    color: '#fff'
  }
};

export const AddButton = {
  height: 40,
  minWidth: 40,
  width: 40,
  borderRadius: '50%',
  boxShadow: 1
};

export const PricingSection = {
  marginTop: 0,
  padding: 2,
  backgroundColor: 'rgba(33, 150, 243, 0.1)',
  border: '1px solid rgba(33, 150, 243, 0.3)',
  borderTop: 'none',
  borderRadius: '0 0 4px 4px'
};

export const AgreedPriceInput = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(33, 150, 243, 0.1)',
    borderRadius: 1,
    '& fieldset': {
      borderColor: 'rgba(33, 150, 243, 0.3)'
    },
    '&:hover fieldset': {
      borderColor: 'rgba(33, 150, 243, 0.5)'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#2196f3'
    }
  },
  '& .MuiInputBase-input': {
    color: '#fff',
    fontSize: '0.9rem',
    padding: '10px 12px',
    fontWeight: 'bold'
  },
  '& input[type=number]': {
    '-moz-appearance': 'textfield'
  },
  '& input[type=number]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  },
  '& input[type=number]::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  }
};

export const FooterBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: 0,
  paddingTop: theme.spacing(2),
  paddingRight: theme.spacing(3),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(3),
  borderTop: '1px solid rgba(255,255,255,0.1)',
  backgroundColor: '#1e1e1e'
}));